import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../../../features/utils";
import Token from "../../../state/token/index";

export const getCommonRequestData = ({ state, encounterToken }) => {

  // Used by:
  // - getTriageQuestions, getTriageAdditionalQuestions
  // - getTriageScoreFromAnswers
  
  const { triageRequest, currentSymptomsMap } = state
  const {
    sessionId,
    ageInDays,
    pregnant,
    gender
  } = triageRequest

  let primaryConceptId = 0
  const secondaryConceptIdArray = []

  for (const key of Object.keys(currentSymptomsMap)) {

    const { conceptId } = currentSymptomsMap[key]

    if (!primaryConceptId) {
      primaryConceptId = conceptId
      continue
    }

    secondaryConceptIdArray.push(conceptId)
  }
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  const data = {
    identifier: sessionId,
    Token : encounterToken,
    primaryConceptId,
    secondaryConceptIdArray,

    days: ageInDays,

    // Internal: 0: Not pregnant, 1: Pregnant
    // API:      1: Not pregnant, 2: Pregnant, 3: Post-partum
    pregnancyStatus: pregnant ? 1 : 0,

    gender,    
    jwtAccessToken : jwtAccess_Token,
    accessToken : access_Token,
  }

  return data
}

export const enCounterToken = () => {
  Token.setToken();
  const encounterToken = Token.getToken();
  localStorage.setItem("token", encounterToken);
}
